import * as ActionTypes from "../../constants/actiontypes/backoffice/aidavie";
import * as Loadings from "../../constants/loadings/backoffice/aidavie";
import AidavieFile from "../../constants/models/backoffice/aidavie";
import toastConf from "../../utils/toasterConfiguration";
import { toast } from "react-toastify";

const AidavieReducer = (
	state = {
		isLoading: [],
		items: [],
		nextPage: true,
		totalPages: 0,
		totalRecords: 0,
		currentPage: 0,
	},
	action
) => {
	switch (action.type) {
		case ActionTypes.FETCH_AIDAVIE_FILES_REQUEST:
			if (!state.isLoading.includes(Loadings.FETCHING_AIDAVIE_FILES)) {
				state.isLoading = state.isLoading.concat(Loadings.FETCHING_AIDAVIE_FILES);
			}
			return { ...state };

		case ActionTypes.FETCH_AIDAVIE_FILES_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.FETCHING_AIDAVIE_FILES);

			//action.data.length < pageLimit
			if (action.data.pageNumber + 1 === action.data.totalPages) {
				state.nextPage = false;
			} else {
				state.nextPage = true;
			}

			if (state.items) {
				const moreItems = action.data.items.map((user) => new AidavieFile(user));
				state.items = [...moreItems];
			} else {
				state.items = action.data.items.map((user) => new AidavieFile(user));
			}
			state.totalPages = action.data.totalPages;
			state.totalRecords = action.data.totalRecords;
			state.currentPage = action.data.pageNumber + 1;

			return { ...state };

		case ActionTypes.FETCH_AIDAVIE_FILES_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.FETCHING_AIDAVIE_FILES);
			return { ...state };

		case ActionTypes.UPDATE_OPERATOR_REQUEST:
			if (!state.isLoading.includes(Loadings.UPDATING_OPERATOR)) {
				state.isLoading = state.isLoading.concat(Loadings.UPDATING_OPERATOR);
			}
			return { ...state };

		case ActionTypes.UPDATE_OPERATOR_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.UPDATING_OPERATOR);
			state.items = state.items.map((item) => {
				if (item.id === action.data.id) return new AidavieFile(action.data);

				return item;
			});
			toast.success("Le chargé du dossier a été modifié avec succès.", toastConf);
			return { ...state };
		case ActionTypes.UPDATE_OPERATOR_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.UPDATING_OPERATOR);
			toast.success("Erreur lors de la modification du chargé du dossier", toastConf);
			return { ...state };

		default:
			return state;
	}
};
export default AidavieReducer;
